"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const ExtrasGraphicIcon = props => {
  const {
      size = 48
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "EXTRAS-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.466 4.6-.129.006A1.267 1.267 0 0 0 9.2 5.866l-.001 1.8h-1.8c-.7 0-1.266.568-1.266 1.267V12l.006.13a1.267 1.267 0 0 0 1.26 1.137h1.8v1.8c0 .7.568 1.267 1.267 1.267h3.068l.129-.006a1.267 1.267 0 0 0 1.137-1.26v-1.801h1.8c.7 0 1.267-.567 1.267-1.267V8.933l-.006-.129a1.267 1.267 0 0 0-1.26-1.137L14.8 7.666v-1.8c0-.7-.567-1.266-1.266-1.266h-3.068m0 1h3.068c.147 0 .266.12.266.266v2.3a.5.5 0 0 0 .5.5h2.3c.148 0 .267.12.267.267V12c0 .148-.12.267-.266.267h-2.3a.5.5 0 0 0-.5.5v2.3c0 .148-.12.267-.267.267h-3.068a.267.267 0 0 1-.266-.267v-2.3a.5.5 0 0 0-.5-.5H7.4A.267.267 0 0 1 7.132 12V8.933c0-.147.12-.266.266-.266h2.3a.5.5 0 0 0 .5-.5v-2.3c0-.148.12-.267.267-.267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.559.001-.554-.002A22.685 22.685 0 0 0 2.72 1.892a2.022 2.022 0 0 0-1.188 1.855v7.78c0 5.244 3.23 9.945 8.123 11.828l1.065.409a3.567 3.567 0 0 0 2.56 0l1.065-.409a12.673 12.673 0 0 0 8.123-11.828V3.743a2.018 2.018 0 0 0-1.18-1.847 22.696 22.696 0 0 0-8.73-1.895m-1.094 1 .54-.002a21.685 21.685 0 0 1 8.875 1.81c.358.163.59.53.588.93v7.788c0 4.83-2.975 9.16-7.482 10.895l-1.064.409a2.567 2.567 0 0 1-1.844 0l-1.064-.41a11.673 11.673 0 0 1-7.482-10.894V3.743a1.02 1.02 0 0 1 .596-.938 21.68 21.68 0 0 1 8.337-1.804"
  })));
};
ExtrasGraphicIcon.displayName = "ExtrasGraphicIcon";
ExtrasGraphicIcon.iconName = "Extras";
export default ExtrasGraphicIcon;